import Message from './styled';

export default Message;
